<template>
    <div class="hello">
      <ul class="newslist">
        <li v-for="(item,index) in news.slice(0,5)">
          <i><img src="../../assets/icons/arrow_red.png" alt=""></i>
          <router-link :to="{path: `/news/${item.id}`}">{{item.title}}</router-link>
          <span>{{item.createdate.substr(0,10)}}</span>
        </li>
      </ul>
    </div>
</template>

<script>
  import { mapState } from 'vuex'
  import { newsList } from '../../service/api'
  export default {
    name: 'hello',
    components: {
    },
    data () {
      return {
        msg: 'hello'
      }
    },
    computed: {
      ...mapState(['news'])
    }
  }
</script>
<style type="text/scss" rel="stylesheet/scss" lang="scss">
  .newslist li{
    padding: 0 0 30px 15px;
    text-align: left;
    i{
      vertical-align: baseline;
      img{
        vertical-align: initial;
        width: 10px;
      }
    }
    a{
      color: #333333;
      display: inline-block;
    }
    span{
      display: inline-block;
      float: right;
      color: #666666;
      margin-right: 40px;
    }
  }
  @media only screen and (max-width: 768px){
    .newslist li{
      padding-left: 0;
      font-size: 14px;
      padding-bottom: 15px;
      span{
        display: none;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/home/News.vue